import { Grid2 } from "@mui/material";
import PlanFeatureStyle from "../PlanFeatures/PlanFeatureStyle.module.scss";
const PlanFeatures = (props) => {
    const {icon,featureName,featureValue}=props;
  return (
    <Grid2 className={PlanFeatureStyle.block}>
      <Grid2 className={PlanFeatureStyle.intial}>
        <Grid2 >{icon}</Grid2>
        <Grid2>{featureName}</Grid2>
      </Grid2>
      <Grid2 className={PlanFeatureStyle.value}>{featureValue}</Grid2>
    </Grid2>
  );
};

export default PlanFeatures;
